<template>
  <div class="cart_order">
    <!--地址-->
      <div class="order_address">
        <div v-if="address.length>0">
          <div class="box" v-for="(item, index) in address" :key="index">
            <template v-if="(item.id + '') == addressId">
              <img class="img_top" src="../../assets/images/icon_17.png" />
              <div @click="di_zhi">
                <div class="left">
                  <div class="name">{{item.name}}</div>
                  <img
                    class="left_img"
                    v-if="item.defaultStatus == 1"
                    src="../../assets/images/icon_16.png"
                  />
                </div>
                <div class="right">
                  <i class="van-icon van-icon-arrow van-cell__right-icon rightboxone"></i>
                  <div class="phone">{{item.phone}}</div>
                  <div class="detail">{{addrSplit(item.addrNameFull)}}{{item.detailAddress}}</div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div v-else>
          <div class="boxTwo" @click="addassets">
              <img class="img_top" src="../../assets/images/icon_17.png" />
              <div class="boxTwo_div">
                <div style="float:left;">
                  <van-icon name="add-o" />
                </div>
                <div class="boxTwoadd">快去添加收货地址吧</div>
              </div>
          </div>
        </div>
      </div>
    <!-- 商品合计 -->
    <div class="cart_view">
      <div class="box">
        <div class="left">商品合计</div>
        <div class="right">
            ￥<span v-if="integrUse == 0">{{payAmount - couponAmount }}</span><span v-if="integrUse != 0">{{payAmount - integrAmount - couponAmount }}</span>
        </div>
      </div>
    </div>
    <!-- 优惠券 -->
    <div class="cart_viewCell" >
      <div class="celss" @click="GoCoupon">
        <van-cell title="优惠券" is-link :value="Preferential" />
      </div>
    </div>
    <!-- 折扣优惠 -->
    <div class="cart_view" v-if="disrice != 0">
      <div class="box">
        <div class="left">折扣优惠</div>
        <div class="right">￥{{disrice}}</div>
      </div>
    </div>
    <!-- 运费 -->
    <div class="cart_view">
      <div class="box" style="border:none">
        <div class="left">
          <div class="title_text">运费</div>
        </div>
        <div class="right">￥{{freight}}</div>
      </div>
    </div>
    <!-- 商品详情 -->
    <div class="cart_box">
      <div class="cart_good" v-for="(orderItem,indes) in orderItem" :key="indes">
        <div class="img_1">
          <img :src="orderItem.productPic" />
        </div>
        <div class="right">
          <div class="name">
            <div class="autark" v-if="orderItem.supplierCode == 'ZY'">自营</div>
            {{orderItem.productName}}
          </div>
          <div class="speci">{{orderItem.productAttr}}</div>
          <div class="price_origi">
            <div class="price">￥{{orderItem.price}}</div>
            <div class="origi">￥{{orderItem.originalPrice}}</div>
            <div class="disco">折￥{{orderItem.discountPrice}}</div>
          </div>
        </div>
        <div class="num">x{{orderItem.quantity}}</div>
      </div>
    </div>
    <div class="absolute"></div>
    <!-- 提交 -->
    <div class="submit">
      <div class="left">
        实付：￥<span v-if="integrUse == 0">{{payAmount - couponAmount }}</span><span v-if="integrUse != 0">{{payAmount - integrAmount - couponAmount }}</span>
      </div>
      <div :class="agree == true ? 'active right' : 'right'" @click="orderPay">付款</div>
    </div>
  </div>
</template>

<script>
import { Icon, Cell, Toast } from 'vant'
import {
  orderConfirmBuy,
  orderSubmitBuy,
  address,
  // orderInfo,
  orderConfirmCart,
  orderSubmitCart
} from '../../request/api.js'
export default {
  name: 'OrderPage',
  components: {
    [Icon.name]: Icon,
    [Cell.name]: Cell
  },
  data () {
    return {
      show: false,
      idArr: [], // 商品id
      abroad: false, // 默认无海外商品
      abroadTipsShow: true, // 海外商品提示
      idenName: '', // 姓名
      idenCard: '', // 身份证
      orderItem: [], // 订单列表
      address: [], // 收货地址
      addressId: '', // 收货地址id
      invoice: [], // 发票列表
      invoiceId: '', // 发票id
      disrice: '0', // 分销折扣
      totals: '', // 总价格
      total: '', // 实付价格
      payAmount: '',
      origi: '', // 划线价
      // integration: 0, //总积分
      integrUsable: 0, // 可用积分
      integrAmount: 0, // 可用抵用费用
      integrAmounts: 0, // 可用抵用费用
      integrUse: 0, // 使用积分分值
      integrBool: false,
      couponList: [], // 优惠券列表
      couponId: '', // 优惠券id
      couponName: '', // 优惠券name
      couponNote: '', // 优惠券满减条件
      couponAmount: 0, // 优惠券满减金额
      textCont: '', // 文字内容
      agrees: 0, // 发票是否勾选
      rise: '个人', // 发票明细
      agree: false, // 是否同意协议
      agreeBool: false,
      invoiBool: false,
      freight: '0.00', // 运费
      exceedClick: 0, // 多次点击
      Preferential: '暂无可用优惠券',
      sou_list: [] // 所有地址
    }
  },
  activated() {
    window.scrollTo(0, 0)
    document.documentElement.scrollTop = 0
  },
  created () {
    address().then(res => {
      console.log(res)
      if (res.code === 200) {
        if (res.data.length !== 0) {
          this.address = res.data
          if (this.$route.query.AddressID !== undefined && this.$route.query.AddressID !== '') {
            this.addressId = this.$route.query.AddressID
          } else {
            this.addressId = res.data[0].id
          }
          return this.addressId
        }
      }
    }).then(response => {
      console.log(response)
      if (this.$route.query.Cart) {
        const params = {
          ids: this.$route.query.Cart,
          memberReceiveAddressId: response
        }
        console.log(params)
        orderConfirmCart(params).then(res => {
          console.log(res.data)
          if (res.code === 200) {
            this.sou_list = res.data.memberReceiveAddressList
            this.orderItem = res.data.cartPromotionItemList
            this.integrUsable =
            res.data.calcAmount.memberIntegrationUsable < 0
              ? 0
              : res.data.calcAmount.memberIntegrationUsable
            this.integrAmount =
            res.data.calcAmount.integrationAmount < 0
              ? 0
              : res.data.calcAmount.integrationAmount
            this.couponList = res.data.couponHistoryDetailList
            this.freight = res.data.calcAmount.freightAmount
            this.payAmount = res.data.calcAmount.payAmount
            this.disrice = res.data.calcAmount.discountAmount
            var totalNum = 0
            for (var i = 0; i < res.data.cartPromotionItemList.length; i++) {
              totalNum +=
              res.data.cartPromotionItemList[i].price *
              res.data.cartPromotionItemList[i].quantity
            }
            this.totals = totalNum
            this.total = totalNum
            if (res.data.couponHistoryDetailList.length > 0) {
              this.Preferential = '可使用优惠券' + res.data.couponHistoryDetailList.length + '张'
            }
            if (sessionStorage.getItem('couponId')) {
              this.couponId = sessionStorage.getItem('couponId')
            }
            if (sessionStorage.getItem('amount')) {
              this.couponAmount = sessionStorage.getItem('amount')
            }
            if (sessionStorage.getItem('amountIndex')) {
              this.Preferential = res.data.couponHistoryDetailList[sessionStorage.getItem('amountIndex')].coupon[0].name
            } else {
              if (res.data.couponHistoryDetailList.length > 0) {
                this.Preferential = '可使用优惠券' + res.data.couponHistoryDetailList.length + '张'
              }
            }
            console.log(sessionStorage.getItem('amountIndex'))
          }
        }).catch(res => {
          console.log(res)
        })
        if (sessionStorage.getItem('addindex') !== null) {
          address().then(res => {
            console.log(res)
            if (res.code === 200) {
              if (res.data.length !== 0) {
                this.address = res.data
                this.addressId = res.data[sessionStorage.getItem('addindex')].id
              }
            }
          }).catch(res => {
            console.log(res)
          })
        } else {
          this.loadAddressCart()
        }
      } else {
        // 直接购买确认订单
        const params = {
          productId: this.$route.query.id,
          productSkuId: this.$route.query.sp1id,
          quantity: this.$route.query.number,
          memberReceiveAddressId: response
        }
        orderConfirmBuy(params).then(res => {
          console.log(res)
          if (res.code === 200) {
            console.log(res.data)
            this.sou_list = res.data.memberReceiveAddressList
            this.orderItem = res.data.cartPromotionItemList
            this.integrUsable =
              res.data.calcAmount.memberIntegrationUsable < 0
                ? 0
                : res.data.calcAmount.memberIntegrationUsable
            this.integrAmount =
              res.data.calcAmount.integrationAmount < 0
                ? 0
                : res.data.calcAmount.integrationAmount
            this.couponList = res.data.couponHistoryDetailList
            this.freight = res.data.calcAmount.freightAmount
            this.payAmount = res.data.calcAmount.payAmount
            this.disrice = res.data.calcAmount.discountAmount
            var totalNum = 0
            for (var i = 0; i < res.data.cartPromotionItemList.length; i++) {
              totalNum +=
                res.data.cartPromotionItemList[i].price *
                res.data.cartPromotionItemList[i].quantity
            }
            this.totals = totalNum
            this.total = totalNum
            if (res.data.couponHistoryDetailList.length > 0) {
              this.Preferential = '可使用优惠券' + res.data.couponHistoryDetailList.length + '张'
            }
            if (sessionStorage.getItem('couponId')) {
              this.couponId = sessionStorage.getItem('couponId')
              // if (this.couponId !== 0) {
              //   sessionStorage.setItem('couponId', '')
              // }
            }
            if (sessionStorage.getItem('amount')) {
              this.couponAmount = sessionStorage.getItem('amount')
              // if (this.couponAmount !== 0) {
              //   sessionStorage.setItem('amount', '')
              // }
            }
            if (sessionStorage.getItem('amountIndex')) {
              this.Preferential = res.data.couponHistoryDetailList[sessionStorage.getItem('amountIndex')].coupon[0].name
            } else {
              if (res.data.couponHistoryDetailList.length > 0) {
                this.Preferential = '可使用优惠券' + res.data.couponHistoryDetailList.length + '张'
              }
            }
            console.log(this.Preferential)
            console.log(sessionStorage.getItem('amountIndex'))
          }
        })
        if (sessionStorage.getItem('addindex') !== null) {
          address().then(res => {
            console.log(res)
            if (res.code === 200) {
              if (res.data.length !== 0) {
                this.address = res.data
                this.addressId = res.data[sessionStorage.getItem('addindex')].id
              }
            }
          }).catch(res => {
            console.log(res)
          })
        } else {
          this.loadAddress()
        }
      }
    }).catch(res => {
      console.log(res)
    })
    console.log(this.address)
    // this.addressId = this.$route.query.AddressID
  },
  beforeRouteLeave (to, from, next) {
    // 如果页面进入选择地址不用清除优惠券反之清除优惠券
    console.log(to, from)
    if (to.name !== 'addressData') {
      sessionStorage.removeItem('amount')
      sessionStorage.removeItem('couponId')
      sessionStorage.removeItem('amountIndex')
      sessionStorage.removeItem('addindex')
    }
    next()
  },
  methods: {
    // 收货地址
    loadAddress () {
      address().then(res => {
        console.log(res)
        if (res.code === 200) {
          if (res.data.length !== 0) {
            this.address = res.data
            if (this.$route.query.AddressID !== undefined && this.$route.query.AddressID !== '') {
              this.addressId = this.$route.query.AddressID
            } else {
              this.addressId = res.data[0].id
            }
          }
          console.log(this.addressId)
        }
      }).catch(res => {
        console.log(res)
      })
    },
    // 去优惠券页面
    GoCoupon() {
      if (this.couponList.length !== 0) {
        const list = JSON.stringify(this.couponList)
        this.$router.push({ path: '/Coupon', query: { couponList: list } })
      }
    },
    // 购物车地址
    loadAddressCart() {
      address()
        .then(res => {
          console.log(res)
          if (res.code === 200) {
            if (res.data.length !== 0) {
              this.address = res.data
              this.addressId = res.data[0].id
            }
            console.log(this.addressId)
          }
        })
        .catch(res => {
          console.log(res)
        })
    },
    addrSplit (name) {
      return name.replace(/-/g, '')
    },
    // 地址添加
    addassets() {
      this.$router.push('/addressList')
    },
    // 地址列表
    di_zhi() {
      this.$router.push('/addressData')
    },
    // 支付
    orderPay() {
      if (this.address.length !== 0) {
        if (this.$route.query.Cart) {
          var orderSubmitCartParams = {
            couponId: this.couponId ? this.couponId : 0,
            ids: this.$route.query.Cart,
            inviteCode: '',
            invoiceEmail: this.invoiceEmail,
            invoiceHave: 0,
            invoiceNumber: this.number,
            invoicePhone: this.invoiceTel,
            invoiceRise: this.rise,
            invoiceType: 0,
            memberInvoiceId: 0,
            memberReceiveAddressId: this.addressId * 1,
            message: '',
            payType: 0,
            sourceType: 2,
            useIntegration: this.integrUse ? this.integrUse : 0,
            requestId: localStorage.getItem('requestId'),
            deductionId: 0,
            payAmount: this.integrUse === 0 ? (this.payAmount - this.couponAmount) + '' : (this.payAmount - this.integrAmount - this.couponAmount) + ''
          }
          // 实付：￥<span v-if="">{{}}</span><span v-if="integrUse != 0">{{}}</span>
          console.log(this.payAmount - this.couponAmount)
          console.log(orderSubmitCartParams)
          console.log('orderSubmitCart')
          orderSubmitCart(orderSubmitCartParams).then(res => {
            if (res.code === 200) {
              console.log(res.data)
              return res.data
            }
          }).then(res => {
            if (sessionStorage.getItem('addindex') !== null) {
              // payAmount - couponAmount + freight
              if (this.integrUse === 0) {
                var pay = JSON.stringify({ id: res, money: (this.payAmount - this.couponAmount) + '', time: this.time, address: this.sou_list[sessionStorage.getItem('addindex')] })
                sessionStorage.setItem('pay', pay)
                console.log(sessionStorage.getItem('pay', pay))
                this.$router.push({
                  path: '/pay'
                // query: {
                //   id: res,
                //   money: this.payAmount,
                //   time: this.time,
                //   addressId: this.addressId
                // }
                })
              } else {
                var paya = JSON.stringify({ id: res, money: (this.payAmount - this.integrAmount - this.couponAmount) + '', time: this.time, address: this.sou_list[sessionStorage.getItem('addindex')] })
                sessionStorage.setItem('pay', paya)
                console.log(sessionStorage.getItem('pay', paya))
                this.$router.push({
                  path: '/pay'
                // query: {
                //   id: res,
                //   money: this.payAmount,
                //   time: this.time,
                //   addressId: this.addressId
                // }
                })
              }
            } else {
              if (this.integrUse === 0) {
                var payb = JSON.stringify({ id: res, money: (this.payAmount - this.couponAmount) + '', time: this.time, address: this.sou_list[0] })
                sessionStorage.setItem('pay', payb)
                console.log(sessionStorage.getItem('pay', payb))
                this.$router.push({
                  path: '/pay'
                // query: {
                //   id: res,
                //   money: this.payAmount,
                //   time: this.time,
                //   addressId: this.addressId
                // }
                })
              } else {
                var payc = JSON.stringify({ id: res, money: (this.payAmount - this.integrAmount - this.couponAmount) + '', time: this.time, address: this.sou_list[0] })
                sessionStorage.setItem('pay', payc)
                console.log(sessionStorage.getItem('pay', payc))
                this.$router.push({
                  path: '/pay'
                // query: {
                //   id: res,
                //   money: this.payAmount,
                //   time: this.time,
                //   addressId: this.addressId
                // }
                })
              }
            }
          }).catch(res => {
            console.log(res)
          })
        } else {
          var orderSubmitBuyParam = {
            productId: Number(this.$route.query.id),
            productSkuId: Number(this.$route.query.sp1id),
            quantity: this.$route.query.number * 1,
            memberReceiveAddressId: this.addressId * 1,
            couponId: this.couponId ? this.couponId : 0,
            memberInvoiceId: 0,
            useIntegration: this.integrUse ? this.integrUse : 0,
            message: '',
            payType: 0,
            sourceType: 2,
            invoiceEmail: this.invoiceEmail,
            invoiceHave: 0,
            invoiceNumber: this.number,
            invoicePhone: this.invoiceTel,
            invoiceRise: this.rise,
            invoiceType: 0,
            payAmount: this.integrUse === 0 ? (this.payAmount - this.couponAmount) + '' : (this.payAmount - this.integrAmount - this.couponAmount) + '',
            requestId: localStorage.getItem('requestId'),
            deductionId: 0
          }
          console.log(this.payAmount - this.couponAmount, this.freight, 'this.freight')
          console.log(orderSubmitBuyParam)
          console.log('orderSubmitBuy')
          orderSubmitBuy(orderSubmitBuyParam).then(res => {
            console.log(res.code)
            if (res.code === 200) {
              console.log(res.data)
              return res.data
            } else {
              Toast.fail(res.message)
              return false
            }
          }).then(res => {
            console.log(res)
            if (res !== false) {
              if (sessionStorage.getItem('addindex') !== null) {
                // var pay = JSON.stringify({ id: res, money: this.payAmount, time: this.time, address: this.sou_list[sessionStorage.getItem('addindex')] })
                // sessionStorage.setItem('pay', pay)
                // console.log(sessionStorage.getItem('pay', pay))
                // this.$router.push({
                //   path: '/pay'
                // // query: {
                // //   id: res,
                // //   money: this.payAmount,
                // //   time: this.time,
                // //   addressId: this.addressId
                // // }
                // })
                if (this.integrUse === 0) {
                  var payb = JSON.stringify({ id: res, money: (this.payAmount - this.couponAmount) + '', time: this.time, address: this.sou_list[sessionStorage.getItem('addindex')] })
                  sessionStorage.setItem('pay', payb)
                  console.log(sessionStorage.getItem('pay', payb))
                  this.$router.push({
                    path: '/pay'
                  // query: {
                  //   id: res,
                  //   money: this.payAmount,
                  //   time: this.time,
                  //   addressId: this.addressId
                  // }
                  })
                } else {
                  var payc = JSON.stringify({ id: res, money: (this.payAmount - this.integrAmount - this.couponAmount) + '', time: this.time, address: this.sou_list[sessionStorage.getItem('addindex')] })
                  sessionStorage.setItem('pay', payc)
                  console.log(sessionStorage.getItem('pay', payc))
                  this.$router.push({
                    path: '/pay'
                  // query: {
                  //   id: res,
                  //   money: this.payAmount,
                  //   time: this.time,
                  //   addressId: this.addressId
                  // }
                  })
                }
              } else {
                // var paya = JSON.stringify({ id: res, money: this.payAmount, time: this.time, address: this.sou_list[0] })
                // sessionStorage.setItem('pay', paya)
                // console.log(sessionStorage.getItem('pay', paya))
                // this.$router.push({
                //   path: '/pay'
                // // query: {
                // //   id: res,
                // //   money: this.payAmount,
                // //   time: this.time,
                // //   addressId: this.addressId
                // // }
                // })
                if (this.integrUse === 0) {
                  var payd = JSON.stringify({ id: res, money: (this.payAmount - this.couponAmount) + '', time: this.time, address: this.sou_list[0] })
                  sessionStorage.setItem('pay', payd)
                  console.log(sessionStorage.getItem('pay', payd))
                  this.$router.push({
                    path: '/pay'
                  // query: {
                  //   id: res,
                  //   money: this.payAmount,
                  //   time: this.time,
                  //   addressId: this.addressId
                  // }
                  })
                } else {
                  var paye = JSON.stringify({ id: res, money: (this.payAmount - this.integrAmount - this.couponAmount) + '', time: this.time, address: this.sou_list[0] })
                  sessionStorage.setItem('pay', paye)
                  console.log(sessionStorage.getItem('pay', paye))
                  this.$router.push({
                    path: '/pay'
                  // query: {
                  //   id: res,
                  //   money: this.payAmount,
                  //   time: this.time,
                  //   addressId: this.addressId
                  // }
                  })
                }
              }
            } else {
              return false
            }
          }).catch(err => {
            console.log(err)
            return false
          })
        }
      } else {
        Toast.fail('请添加收货地址')
      }
    }
  },
  computed: {
    time() {
      // 获取当前时间戳
      var timestamp = Date.parse(new Date())
      timestamp = timestamp / 1000
      console.log('当前时间戳为：' + timestamp)
      // 获取当前时间
      var n = timestamp * 1000
      var date = new Date(n)
      // 年
      var Y = date.getFullYear()
      // 月
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      // 日
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      // 时
      var h = date.getHours()
      // 分
      var m = date.getMinutes()
      // 秒
      var s = date.getSeconds()
      console.log('当前时间：' + Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s)
      // 加一天的时间戳(24 * 60 * 60)
      // 加一小时的时间戳(60 * 60)
      var tomorrowtimetamp = timestamp + 60 * 60
      // 加一小时的时间
      var nto = tomorrowtimetamp * 1000
      var tomorrowdate = new Date(nto)
      // 加一小时后的年份
      var Ytomorrow = tomorrowdate.getFullYear()
      // 加一小时后的月份
      var Mtomorrow = (tomorrowdate.getMonth() + 1 < 10 ? '0' + (tomorrowdate.getMonth() + 1) : tomorrowdate.getMonth() + 1)
      // 加一小时后的日期
      var Dtomorrow = tomorrowdate.getDate() < 10 ? '0' + tomorrowdate.getDate() : tomorrowdate.getDate()
      // 加一小时后的时刻
      var htomorrow = tomorrowdate.getHours()
      // 加一小时后的分钟
      var mtomorrow = tomorrowdate.getMinutes()
      // 加一小时后的秒数
      var stomorrow = tomorrowdate.getSeconds()
      console.log('加一小时后的时间：' + Ytomorrow + '-' + Mtomorrow + '-' + Dtomorrow + ' ' + htomorrow + ':' + mtomorrow + ':' + stomorrow)
      return Ytomorrow + '-' + Mtomorrow + '-' + Dtomorrow + ' ' + htomorrow + ':' + mtomorrow + ':' + stomorrow
    }
  }
}
</script>

<style lang="less" scoped>
@pierce: ~">>>";
@widthframe: 690px;
* {
  box-sizing: border-box;
}
.autark {
  float: left;
  width: 76px;
  height: 38px;
  line-height: 34px;
  text-align: center;
  font-size: 24px;
  border-radius: 6px;
  font-weight: 400;
  margin-right: 6px;
  background: #E33F36;
  border: 1px solid #E33F36; /* no*/
  color: rgba(255, 255, 255, 1);
}
.cart_order {
  // min-height: 95vh;
  margin-top: 1vh;
  padding-bottom: 100px;
  background: #f2f2f2;
}
/* 海外 */
.abroad_tips {
  color: rgba(51, 51, 51, 1);
  font-size: 28px;
  line-height: 36px;
  padding: 36px 50px 28px 30px;
  position: relative;
}
.abroad_tips .close {
  width: 60px;
  height: 60px;
  text-align: right;
  padding: 16px 30px 0 0;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 3;
}
.abroad_sfxx,
.abroad_hggd {
  display: block;
}
.abroad_sfxx {
  padding-bottom: 16px;
}
.abroad_hggd {
  font-size: 24px;
  color: rgba(180, 39, 45, 1);
}
/* 地址 */
.order_address {
  margin-bottom: 20px;
}
.order_address .box {
  width: 100%;
  background: #fffdee;
  overflow: hidden;
  position: relative;
}
.order_address .box view {
  line-height: 1;
}
.order_address .box .img_top {
  float: left;
  width: 750px;
  height: 10px;
}
.order_address .box .left,
.order_address .box .right {
  padding: 20px 0;
}
.order_address .box .left {
  float: left;
  width: 170px;
  word-break: break-all;
  padding-left: 30px;
}
.order_address .box .left .left_img {
  width: 66px;
  height: 32px;
  display: block;
}
.order_address .box .left .name {
  color: #333;
  font-size: 28px;
  padding-top: 4px;
}
.order_address .box .left image {
  width: 66px;
  height: 32px;
  margin-top: 12px;
}
.order_address .box .right {
  float: left;
  width: 580px;
  line-height: 1;
  padding-right: 30px;
  position: relative;
}
.order_address .box .right .phone {
  color: #333;
  font-size: 28px;
  padding: 4px 0 12px;
}
.order_address .box .right .detail {
  width: 520px;
  color: #999;
  font-size: 24px;
  line-height: 32px;
  overflow: hidden;
  word-break: break-all;
}
/* 添加收货地址 */
.order_address .add-new-address {
  width: 192px;
  height: 63px;
  text-align: center;
  font-size: 28px;
  color: #333;
  line-height: 63px;
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  margin: 0 auto;
}
.order_address .add-new-address .icon {
  color: #333;
  margin-right: 10px;
}
/* 商品详情 */
.cart_order .cart_box {
  margin-top: 24px;
  padding-left: 30px;
  background: #fff;
  overflow: hidden;
}
.cart_order .cart_box .cart_good {
  padding: 24px 0;
  position: relative;
  overflow: hidden;
  border-top: 1px solid rgba(218, 218, 218, 1); /*no*/
}
.cart_order .cart_box .cart_good:first-child {
  border: none;
}
.cart_order .cart_box .cart_good .img_1 {
  float: left;
  width: 146px;
  height: 146px;
  border-radius: 4px; /*no*/
  margin-right: 20px;
  position: relative;
}
.cart_order .cart_box .cart_good .img_1 img {
  float: left;
  width: 146px;
  height: 146px;
}
.cart_order .cart_box .cart_good .right {
  float: left;
  width: 524px;
}
.cart_order .cart_box .cart_good .right .name {
  color: #333;
  font-size: 28px;
  width: 470px;
  line-height: 32px;
  padding: 10px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cart_order .cart_box .cart_good .right .speci {
  color: #999;
  font-size: 24px;
  line-height: 1;
  padding-bottom: 30px;
}
.cart_order .cart_box .cart_good .right .price_origi {
  font-size: 28px;
  line-height: 1;
  overflow: hidden;
}
.cart_order .cart_box .cart_good .right .price {
  float: left;
  color: #333;
  padding-right: 20px;
}
.cart_order .cart_box .cart_good .right .origi {
  float: left;
  color: #999;
  text-decoration: line-through;
}
.cart_order .cart_box .cart_good .right .disco {
  float: left;
  font-size: 18px;
  color: rgba(219, 94, 34, 1);
  height: 30px;
  line-height: 30px;
  background: rgba(255, 239, 227, 1);
  border-radius: 4px; /*no*/
  padding: 0 12px 0 8px;
  margin-left: 16px;
}
.cart_order .cart_box .cart_good .num {
  color: #333;
  font-size: 28px;
  line-height: 1;
  position: absolute;
  top: 40px;
  right: 30px;
}
.cart_order .cart_box .cart_good .yjfs {
  width: 100%;
  font-size: 24px;
  color: rgba(180, 39, 45, 1);
  padding-top: 16px;
  overflow: hidden;
}
/*  */
.cart_order .cart_view {
  width: 100%;
  background: #fff;
  position: relative;
  overflow: hidden;
}
.cart_order .cart_view .box {
  float: right;
  width: 720px;
  padding: 38px 30px 38px 0;
  border-bottom: 1px solid rgba(218, 218, 218, 1);
}
.cart_order .cart_view .box .left {
  float: left;
  color: #333;
  font-size: 28px;
  line-height: 1;
}
.cart_order .cart_view .box .left image {
  float: left;
  width: 42px;
  height: 42px;
}
.cart_order .cart_view .box .left .text {
  float: left;
  width: 648px;
  padding-left: 24px;
}
.cart_order .cart_view .box .left .text view {
  float: left;
}
.cart_order .cart_view .box .left .title_text {
  float: left;
}
.cart_order .cart_view .box .left .title_icon {
  float: left;
  width: 24px;
  height: 24px;
  margin-top: 2px;
  margin-left: 12px;
}
.cart_order .cart_view .box .right {
  float: right;
  color: #333;
  font-size: 28px;
  line-height: 1;
}
.cart_order .cart_view .box .img_invoice {
  float: left;
  width: 60px;
}
.cart_order .cart_view .box .img_invoice image {
  width: 35px;
  height: 34px;
}
.cart_order .cart_view .box .txt_invoice {
  float: left;
  width: 630px;
}
.cart_order .cart_view .box .txt_invoice .right {
  float: right;
  color: #999;
  line-height: 34px;
  padding-right: 30px;
}

/* 付款 */
.cart_order .submit {
  width: 100%;
  height: 98px;
  background: #fff;
  overflow: hidden;
  position: fixed;
  bottom: 0;
  z-index: 99;
}
.cart_order .submit .left {
  float: left;
  color: #9a2424;
  font-size: 28px;
  line-height: 98px;
  padding-left: 30px;
}
.cart_order .submit .right {
  float: right;
  width: 224px;
  color: #fff;
  font-size: 28px;
  line-height: 98px;
  text-align: center;
  background: #b4272d;
}
.cart_order .submit .right.active {
  background: #dcdcdc;
}
.rightboxone{
  // line-height: 45px;
  float: right;
  font-size: 25px;
  padding-right: 10px;
}
.van-cell__left-icon, .van-cell__right-icon {
    line-height: 90px;
}
.cart_order .cart_viewCell{
  background-color: #fff;
  height: 80px;
  margin-bottom: 40px;
  .celss{
    height: 80px;
    /deep/ .van-cell{
      font-size: 28px;
      line-height: 80px;
      padding-left: 30px;
    }
    /deep/ .van-cell__right-icon{
      line-height: 80px;
    }
  }
}
.order_address .boxTwo {
  width: 750px;
  height: 154px;
  background: #fffdee;
  .boxTwo_div{
    margin-left: 30px;
    padding-top: 55px;
    .boxTwoadd{
      padding-left: 20px;
      float: left;
      height: 50px;
      line-height: 50px;
      font-size: 28px;
    }
  }
}
.van-icon-add-o{
  font-size: 45px;
}
.order_address .boxTwo .img_top {
  float: left;
  width: 750px;
  height: 10px;
}
.absolute {
  width: 100%;
  position: fixed;
  bottom: 0;
  height:1334px;
  background-color: #f2f2f2;
  z-index: -999;
}
</style>
